import { useState, useEffect } from "react";
import { createPortal } from "react-dom";

export default function AvatarViewer({ src, alt = "avatar", className = "", style }) {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!open) return;
    const id = requestAnimationFrame(() => setVisible(true));
    return () => cancelAnimationFrame(id);
  }, [open]);

  const close = () => {
    setVisible(false);
    setTimeout(() => setOpen(false), 200);
  };

  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (e.key === "Escape") close(); };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [open]);

  return (
    <>
      <img
        src={src}
        alt={alt}
        className={`object-cover cursor-pointer ${className}`}
        style={style}
        onClick={() => setOpen(true)}
        draggable={false}
      />

      {open && createPortal(
        <div
          onClick={close}
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: visible ? "rgba(0,0,0,0.82)" : "rgba(0,0,0,0)",
            backdropFilter: visible ? "blur(12px)" : "blur(0px)",
            WebkitBackdropFilter: visible ? "blur(12px)" : "blur(0px)",
            transition: "background 0.2s ease, backdrop-filter 0.2s ease",
          }}
        >
          <img
            src={src}
            alt={alt}
            draggable={false}
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: "min(80vw, 420px)",
              maxHeight: "80vh",
              borderRadius: "18px",
              boxShadow: "0 12px 60px rgba(0,0,0,0.6)",
              objectFit: "contain",
              transform: visible ? "scale(1)" : "scale(0.85)",
              opacity: visible ? 1 : 0,
              transition: "transform 0.22s cubic-bezier(.34,1.56,.64,1), opacity 0.18s ease",
            }}
          />
        </div>,
        document.body
      )}
    </>
  );
}
